<template>
    <div id="homePowerRates" class="power-rates">
        <ejs-grid :dataSource="powerRates" ref="powerRatesGrid" class="home-power-rates" :allowPaging="true" :pageSettings='pageSettings' :queryCellInfo='customiseCell'>
            <e-columns>
                <e-column field='id' :disableHtmlEncode='false' headerText='Id' class="home-power-rates" :visible="false" textAlign='Left'></e-column>
                <e-column field='flag' :disableHtmlEncode='false' headerText='' textAlign='Left' :valueAccessor="valueAccessPower" width="25px"></e-column>
                <e-column field='priceAreaName' :disableHtmlEncode='false' headerText='Price Area' width="120px" textAlign='Left'></e-column>
                <e-column field='newPrice' :disableHtmlEncode='false' headerText='Difference' textAlign='Center' width="115px"></e-column>
                <e-column field='difference' :disableHtmlEncode='false' headerText='Difference' textAlign='Center'></e-column>
                <e-column field='percentageDiff' headerText='Percentage' :disableHtmlEncode='false' textAlign='Right'></e-column>
            </e-columns>
        </ejs-grid>
    </div>
</template>
<script>
    import Vue from "vue";
    import {
        GridPlugin,
        Page,
    } from "@syncfusion/ej2-vue-grids";
    import { getFlagHtml } from '@/common/flags';
    Vue.use(GridPlugin);

    export default {
        created() {
        },
        data() {
            return {
                powerRates: this.$store.state.homePowerRates,
                pageSettings: { pageSize: 9 }
            };
        },
        mounted() {
            //this.$refs.fxRatesGrid.height = "100%";
            //this.$refs.fxRatesGrid.width = "100%";
        },
        methods: {
            valueAccessPower: function (field, data, column) {    
                return getFlagHtml(data); // Make sure to return!
            },
            customiseCell: function (args) {

                if (args.data.difference > 0) {
                    if (!args.data.difference.includes("+") && !args.data.percentageDiff.includes("+")) {
                        args.data.difference = "+" + args.data.difference;
                        args.data.percentageDiff = "+" + args.data.percentageDiff + "%";
                    }
                    args.cell.classList.add("above-0");

                } else if (args.data.difference < 0) {
                    args.cell.classList.add("below-0");

                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }


                } else {

                    args.cell.classList.add('same-0');
                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }

                }
            },
            getFieldName: function (fieldName, data) {
                if (fieldName === "state") {
                    return data.state
                } else if (fieldName === "difference") {
                    return data.difference + " " + data.currencySymbol + "/" + data.tradingUnitName;
                } else if (fieldName === "percentageDiff") {
                    return data.percentageDiff + " " + "%";
                } else if (fieldName === "id") {
                    return data.id;
                } else if (fieldName === "newPrice") {
                    return data.newPrice + " " + data.currencySymbol + "/" + data.tradingUnitName;
                }
            }
        },
        provide: {
            grid: [Page]
        }
    };
</script>

<style>
    .power-rates .e-grid .e-gridheader {
        display: none;
    }

    .power-rates .e-up:before {
        content: "\e56d";
    }

    .power-rates .e-normal:before {
        content: "\e56f";
    }

    .power-rates .e-down:before {
        content: "\e56e";
    }

    /*.power-rates .e-icons.e-icons-grid {
        color: #00ffff;
        font-size: 16px;
        
    }*/

    .power-rates {
        padding: 0px 0px 17px 0px;

    }
    .power-rates .e-grid {
        border-style: none;
        border-radius: 0px;
    }

    .below-0 {
        color: #1a9470 !important;
    }

    .above-0 {
        color: #f25c54 !important;
    }

    .same-0 {
        color: #001c55 !important;
    }
    .border-flag {
        border-radius: 8px;
    }
  
</style>